export default __webpack_public_path__ + "static/media/text.9bc596a7.svg";